import { render, staticRenderFns } from "./MintalMesPrdSubstationPowerRecordList.vue?vue&type=template&id=4aa5f27d&"
import script from "./MintalMesPrdSubstationPowerRecordList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSubstationPowerRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports